// Подписи экрана сида дня — чистые функции без DOM (их импортируют и компоненты экранов, и тесты в node).
import type { BotStyle, DailySpec } from '../types.ts';
import { MUTATORS, mutatorsLabel } from '../engine/mutators.ts';
import { STYLES } from '../engine/bot.ts';
import { BOSSES } from '../engine/bosses.ts';

/** «🍔 Жирная рука» или «Классика» */
export const dailyMutatorLabel = (spec: Pick<DailySpec, 'mutators'>): string => mutatorsLabel(spec.mutators);

/** Полное описание мутатора дня (или классики) */
export function dailyMutatorDesc(spec: Pick<DailySpec, 'mutators'>): string {
  if (!spec.mutators.length) return 'Обычные правила: 20 жизней, рука 5 карт, 4 жетона дохлых колдунов на игрока.';
  return spec.mutators.map((id) => MUTATORS[id].desc).join(' ');
}

/** Боты дня подписью: «🔥 Агрессор · 💰 Скупердяй · 🗡️ Мстительный» */
export function dailyBotsLabel(spec: Pick<DailySpec, 'bots'>): string {
  const name = (s: BotStyle): string => `${STYLES[s].emoji} ${STYLES[s].label[0]?.toUpperCase() ?? ''}${STYLES[s].label.slice(1)}`;
  return spec.bots.map((b) => (b.boss ? `👑 ${BOSSES[b.boss].short}` : name(b.style))).join(' · ');
}

/** Остаток до смены сида: «через 5 ч 12 мин» */
export function endsInLabel(sec: number): string {
  const m = Math.max(1, Math.round(sec / 60));
  if (m < 60) return `через ${m} мин`;
  const hh = Math.floor(m / 60);
  const mm = m % 60;
  return `через ${hh} ч${mm ? ` ${mm} мин` : ''}`;
}

/** Отрыв со знаком: +12 / −3 / 0 */
export const marginLabel = (m: number): string => (m > 0 ? `+${m}` : m < 0 ? `−${-m}` : '0');
